import { View } from "@/types"

export const fromLastPeriodMap = {
    total: '',
    daily: 'from yesterday',
    yearly: 'from last year',
    quarterly: 'from last quarter',
    monthly: 'from last month',
    weekly: 'from last week',
}

export const periodMap: { [key: string]: string } = {
    total: 'Total',
    daily: 'Today',
    weekly: 'Week',
    monthly: 'Month',
    quarterly: 'Quarter',
    yearly: 'Year'
}

export const periodTimeline: Record<View, { count: number, diff: number }> = {
    total: {
        count: 7,
        diff: 1
    },
    daily: {
        count: 7,
        diff: 1
    },
    weekly: {
        count: 7,
        diff: 7
    },
    monthly: {
        count: 12,
        diff: 1
    },
    quarterly: {
        count: 4,
        diff: 4
    },
    yearly: {
        count: 5,
        diff: 1
    },
}

export const monthMap: Record<number, string> = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
}

export enum UserRole {
    SUPER_ADMIN = 'SUPER_ADMIN',
    ADMIN = 'ADMIN',
    QUESTION_MANAGER = 'QUESTION_MANAGER',
    TRIAL = 'TRIAL',
    PREMIUM = 'PREMIUM',
    STANDARD = 'STANDARD',
}

export const ROLES: Record<UserRole | 'ALL', string> = {
    ALL: 'All',
    [UserRole.SUPER_ADMIN]: 'Super Admin',
    [UserRole.ADMIN]: 'Admin',
    [UserRole.QUESTION_MANAGER]: 'Question Manager',
    [UserRole.TRIAL]: 'Trial',
    [UserRole.PREMIUM]: 'Premium',
    [UserRole.STANDARD]: 'Standard',
}

export const ADMIN_ROLES: Partial<typeof ROLES> = {
    [UserRole.ADMIN]: ROLES[UserRole.ADMIN],
    [UserRole.SUPER_ADMIN]: ROLES[UserRole.SUPER_ADMIN],
    [UserRole.QUESTION_MANAGER]: ROLES[UserRole.QUESTION_MANAGER],
}

export const DURATION: Record<string, string> = {
    ALL: 'All',
    MONTHLY: 'Monthly',
    QUARTERLY: 'Quarterly',
    'HALF-YEARLY': 'Half-Yearly',
    YEARLY: 'Yearly'
}
